'use strict';
(() => {
  document.addEventListener('click',event=>{
    const step=event.target.closest('[data-quantity-step]');
    if(step){const input=step.parentElement.querySelector('input');if(step.dataset.quantityStep==='1')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}
    const thumbnail=event.target.closest('[data-product-image]');
    if(thumbnail){const img=thumbnail.closest('[data-product-section]').querySelector('.product-main-image');if(img){event.preventDefault();img.src=thumbnail.dataset.productImage;img.removeAttribute('srcset');}}
  });
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-variant-selector]'))return;
    const select=event.target,section=select.closest('[data-product-section]');
    const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;
    const price=section.querySelector('[data-variant-price]'),button=section.querySelector('[data-add-button]'),quantity=section.querySelector('input[name="quantity"]');
    price.textContent=variant.price;button.disabled=!variant.available;button.textContent=variant.available?'Add to bag +':'Sold out';
    quantity.min=variant.minimum;quantity.step=variant.increment;quantity.value=variant.minimum;
    if(variant.maximum)quantity.max=variant.maximum;else quantity.removeAttribute('max');
    const img=section.querySelector('.product-main-image');if(img&&variant.image){img.src=variant.image;img.removeAttribute('srcset');}
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  });
})();
